import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export const getPvrs = (params: any) => api.get(url.GET_PVRS, params);
export const getPvr = (id: any, params: any) => {
  const populate = [
    "conductedBy",
    "pvrFile",
    "createdby",
    "createdby.agency",
    "updatedby",
    "agency",
    "contractor",
  ];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_PVR + "/" + id, params);
};
export const addPvr = (data: any) => api.createAndUpload(url.ADD_PVR, data);
export const updatePvr = (data: any) =>
  api.updateAndUpload(url.UPDATE_PVR + "/" + data.id, data.formData);
export const deletePvr = (data: any) =>
  api.delete(url.DELETE_PVR + "/" + data.id, data);
export const updatePvrFiles = (data: { id: any; data: { pvrFile: any[] } }) =>
  api.update(url.UPDATE_PVR + "/" + data.id, data);
export const importPvrs = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_PVRS, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
export const exportPVRsToCsv = (params: any) =>
  api.get(url.EXPORT_PVRS_TO_CSV, params);
